import { StyleSheet } from 'react-native';
import { Colors, SharedUnvalidatedStyles } from '@shared/styles';
import { MBDimensions } from '@shared/util/dimensions';
import { reactions } from './types';

const pickReactionSize = 48;
const pickReactionSpacing = 4;

export const UnvalidatedStyles = {
  get pickerWidth(): number {
    const reactionsWidth = reactions.length * pickReactionSize;
    // num reactions - 1 because we have no spacing (padding)
    // at the start or end if the list
    const spacingWidth = (reactions.length - 1) * pickReactionSpacing;
    return reactionsWidth + spacingWidth + pickReactionSpacing;
  },
  get pickerHeight(): number {
    return pickReactionSize + 2 * pickReactionSpacing;
  },
};

export const Styles = StyleSheet.create({
  reactionButtonShadow: {
    ...SharedUnvalidatedStyles.shadow,
    shadowOpacity: 0.7,
    paddingHorizontal: 6,
    borderRadius: 16,
    // background color makes the shadow apply to background instead of its content
    backgroundColor: 'white',
  },
  reactionButtonIcon: {
    width: 35,
    height: 35,
    padding: 0,
  },
  // Emojis are really hard to align. This is inspired by the npm
  // module emoji-mart does it. They use lineHeight: 1.15 on web
  // but we can't do that because 1.15 => 1.15px using react-native-web.
  // Instead we provide it as a pixel value
  stackedReactionEmoji: {
    fontSize: 20,
    textAlign: 'center',
    lineHeight: 20 * 1.15,
    // After switching the font to SF Pro, Safari
    // renders the heart emoji in a weird way.
    // Changing the font family like this solves it.
    fontFamily: '-apple-system',
  },

  stackedReaction: {
    height: 30,
    borderRadius: 30 / 1,
    borderWidth: 2,
    borderColor: Colors.v2.gray05,
    backgroundColor: 'white',
    marginRight: 4,
  },
  stackedReactionSelected: {
    borderColor: Colors.v2.green30,
    borderWidth: 1,
  },
});

export const ListStyles = StyleSheet.create({
  container: {
    maxHeight: MBDimensions.height / 2,
  },
  image: {
    width: 32,
    height: 32,
    borderRadius: 16,
    overflow: 'hidden',
  },
  emoji: {
    fontSize: 24,
  },
});
